import { ColumnOption } from "./domain/MoneySvr.model";

export const SvrConstantColumnOptions: ColumnOption[] = [
  { key: "store_name", label: "Store Name", mandatory: true, selected: true },
  { key: "date", label: "Date", mandatory: true, selected: true },
  {
    key: "date_transaction",
    label: "Date Transaction",
    mandatory: true,
    selected: true,
  },
  { key: "shift", label: "Shift", mandatory: true, selected: true },
  { key: "cashier", label: "Cashier", mandatory: true, selected: true },
  {
    key: "declared_cash",
    label: "Declared Cash",
    mandatory: true,
    selected: true,
  },
  {
    key: "calculated_cash",
    label: "Calculated Cash",
    mandatory: true,
    selected: true,
  },
  {
    key: "cash_over_short",
    label: "Cash Over/Short",
    mandatory: true,
    selected: true,
  },
  {
    key: "variance_declared_deposited",
    label: "Variance Declared/Deposited",
    mandatory: true,
    selected: true,
  },
  {
    key: "total_noncash",
    label: "Total Non-Cash",
    mandatory: true,
    selected: true,
  },
  {
    key: "total_payments",
    label: "Total Payments",
    mandatory: true,
    selected: true,
  },
  {
    key: "overall_sales",
    label: "Overall Sales",
    mandatory: true,
    selected: true,
  },
  {
    key: "transaction_value",
    label: "Transaction Value",
    mandatory: true,
    selected: true,
  },
  {
    key: "netSpecialSales",
    label: "Net Special Sales",
    mandatory: false,
    selected: false,
  },
  {
    key: "cashDeposit",
    label: "Cash Deposit",
    mandatory: true,
    selected: false,
  },
  {
    key: "otherDeposits",
    label: "Other Deposits",
    mandatory: false,
    selected: false,
  },
  {
    key: "creditCardSales",
    label: "Credit Card Sales",
    mandatory: false,
    selected: false,
  },
  {
    key: "creditCardCharge",
    label: "Credit Card Charge",
    mandatory: false,
    selected: false,
  },
  { key: "crMemo", label: "CR Memo", mandatory: false, selected: false },
  { key: "gc", label: "Gift Card", mandatory: false, selected: false },
  { key: "paymaya", label: "PayMaya", mandatory: false, selected: false },
  { key: "vipSold", label: "VIP Sold", mandatory: false, selected: false },
  { key: "vip", label: "VIP", mandatory: false, selected: false },
  {
    key: "centuryShopaholicVouchers",
    label: "Century Shopaholic Vouchers",
    mandatory: false,
    selected: false,
  },
  { key: "gcash", label: "GCash", mandatory: false, selected: false },
  { key: "foodPanda", label: "FoodPanda", mandatory: false, selected: false },
  { key: "honestBee", label: "HonestBee", mandatory: false, selected: false },
  {
    key: "metrodealNet",
    label: "Metrodeal Net",
    mandatory: false,
    selected: false,
  },
  { key: "marketing", label: "Marketing", mandatory: false, selected: false },
  { key: "other", label: "Other", mandatory: false, selected: false },
  { key: "lazada", label: "Lazada", mandatory: false, selected: false },
  { key: "shopee", label: "Shopee", mandatory: false, selected: false },
  { key: "grab", label: "Grab", mandatory: false, selected: false },
  { key: "booky", label: "Booky", mandatory: false, selected: false },
  { key: "poodtrip", label: "Poodtrip", mandatory: false, selected: false },
  { key: "pickaroo", label: "Pickaroo", mandatory: false, selected: false },
  { key: "parahero", label: "Parahero", mandatory: false, selected: false },
  {
    key: "rareFoodShop",
    label: "Rare Food Shop",
    mandatory: false,
    selected: false,
  },
  {
    key: "shopeePay",
    label: "Shopee Pay",
    mandatory: false,
    selected: false,
  },
  { key: "metroMart", label: "MetroMart", mandatory: false, selected: false },
  { key: "zalora", label: "Zalora", mandatory: false, selected: false },
  { key: "eatigo", label: "Eatigo", mandatory: false, selected: false },
  { key: "madison", label: "Madison", mandatory: false, selected: false },
  { key: "smOnline", label: "SM Online", mandatory: false, selected: false },
  { key: "arExe", label: "AR Exe", mandatory: false, selected: false },
  { key: "robinsons", label: "Robinsons", mandatory: false, selected: false },
  { key: "catering", label: "Catering", mandatory: false, selected: false },
  { key: "snackshop", label: "Snackshop", mandatory: false, selected: false },
  { key: "reseller", label: "Reseller", mandatory: false, selected: false },
  { key: "arOps", label: "AR Ops", mandatory: false, selected: false },
  {
    key: "arsmLifestyle",
    label: "AR SM Lifestyle",
    mandatory: false,
    selected: false,
  },
  {
    key: "arBellevuehotel",
    label: "AR Bellevue Hotel",
    mandatory: false,
    selected: false,
  },
  { key: "offsite", label: "Offsite", mandatory: false, selected: false },
  {
    key: "happyappWallet",
    label: "HappyApp Wallet",
    mandatory: false,
    selected: false,
  },
  { key: "hyperMart", label: "HyperMart", mandatory: false, selected: false },
  { key: "leePlaza", label: "Lee Plaza", mandatory: false, selected: false },
  {
    key: "uymatiaoShipping",
    label: "Uymatiao Shipping",
    mandatory: false,
    selected: false,
  },
  { key: "allEasy", label: "All Easy", mandatory: false, selected: false },
  { key: "arAct", label: "AR Act", mandatory: false, selected: false },
  {
    key: "shareTreat",
    label: "Share Treat",
    mandatory: false,
    selected: false,
  },
  {
    key: "bulkWholesale",
    label: "Bulk Wholesale",
    mandatory: false,
    selected: false,
  },
  {
    key: "othersSpecify",
    label: "Others Specify",
    mandatory: false,
    selected: false,
  },
  {
    key: "cateringManual",
    label: "Catering Manual",
    mandatory: false,
    selected: false,
  },
  {
    key: "offsiteSelling",
    label: "Offsite Selling",
    mandatory: false,
    selected: false,
  },
  {
    key: "resellerManual",
    label: "Reseller Manual",
    mandatory: false,
    selected: false,
  },
  {
    key: "snackshopManual",
    label: "Snackshop Manual",
    mandatory: false,
    selected: false,
  },
  {
    key: "deliveryfeeManual",
    label: "Delivery Fee Manual",
    mandatory: false,
    selected: false,
  },
  {
    key: "cartSales",
    label: "Cart Sales",
    mandatory: false,
    selected: false,
  },
  {
    key: "consignment",
    label: "Consignment",
    mandatory: false,
    selected: false,
  },
  {
    key: "totalSpecialSales",
    label: "Total Special Sales",
    mandatory: false,
    selected: false,
  },
  {
    key: "srCitizen",
    label: "Senior Citizen Disc",
    mandatory: false,
    selected: false,
  },
  {
    key: "pwdDisc",
    label: "PWD Discount",
    mandatory: false,
    selected: false,
  },
  {
    key: "otherDisc",
    label: "Other Discount",
    mandatory: false,
    selected: false,
  },
  {
    key: "transactionCountPos",
    label: "Transaction Count POS",
    mandatory: false,
    selected: false,
  },
  {
    key: "gcOriginatingStore",
    label: "GC Originating Store",
    mandatory: false,
    selected: false,
  },
  {
    key: "gcSerialNumber",
    label: "GC Serial Number",
    mandatory: false,
    selected: false,
  },
  {
    key: "terminalId",
    label: "Terminal ID",
    mandatory: false,
    selected: false,
  },
  { key: "voids", label: "Voids", mandatory: false, selected: false },
  { key: "arTei", label: "A/R TEI", mandatory: false, selected: false },
  {
    key: "arSharetrts50",
    label: "A/R SHARETRTS 50",
    mandatory: false,
    selected: false,
  },
  {
    key: "arSharetrts100",
    label: "A/R SHARETRTS 100",
    mandatory: false,
    selected: false,
  },
  {
    key: "arSharetrts200",
    label: "A/R SHARETRTS 200",
    mandatory: false,
    selected: false,
  },
  {
    key: "arSharetrts300",
    label: "A/R SHARETRTS 300",
    mandatory: false,
    selected: false,
  },
  {
    key: "arSharetrts500",
    label: "A/R SHARETRTS 500",
    mandatory: false,
    selected: false,
  },
  {
    key: "arSmTrentasticBundles",
    label: "A/R SM TRENTASTIC BUNDLES",
    mandatory: false,
    selected: false,
  },
];
/**
 * 'svrKeyMap' is declared but its value is never read.ts(6133)
 */

// export const svrKeyMap: SvrKeyMap = {
//   "ID": "id",
//   "Store Name": "store_name",
//   "Date": "date",
//   "Shift": "shift",
//   "Cashier": "cashier",
//   "Declared Cash": "declared_cash",
//   "Calculated Cash": "calculated_cash",
//   "Net Special Sales": "netSpecialSales",
//   "Cash Over/Short": "cash_over_short",
//   "Date Transaction": "date_transaction",
//   "Cash Deposit": "cashDeposit",
//   "Variance Declared/Deposited": "variance_declared_deposited",
//   "Other Deposits": "otherDeposits",
//   "Credit Card Sales": "creditCardSales",
//   "Credit Card Charge": "creditCardCharge",
//   "CR Memo": "crMemo",
//   "Gift Card": "gc",
//   "PayMaya": "paymaya",
//   "VIP Sold": "vipSold",
//   "VIP": "vip",
//   "Century Shopaholic Vouchers": "centuryShopaholicVouchers",
//   "GCash": "gcash",
//   "FoodPanda": "foodPanda",
//   "HonestBee": "honestBee",
//   "Metrodeal Net": "metrodealNet",
//   "Marketing": "marketing",
//   "Other": "other",
//   "Lazada": "lazada",
//   "Shopee": "shopee",
//   "Grab": "grab",
//   "Booky": "booky",
//   "Poodtrip": "poodtrip",
//   "Pickaroo": "pickaroo",
//   "Parahero": "parahero",
//   "Rare Food Shop": "rareFoodShop",
//   "Shopee Pay": "shopeePay",
//   "MetroMart": "metroMart",
//   "Zalora": "zalora",
//   "Eatigo": "eatigo",
//   "Madison": "madison",
//   "SM Online": "smOnline",
//   "AR Exe": "arExe",
//   "Robinsons": "robinsons",
//   "Catering": "catering",
//   "Snackshop": "snackshop",
//   "Reseller": "reseller",
//   "AR Ops": "arOps",
//   "AR SM Lifestyle": "arsmLifestyle",
//   "AR Bellevue Hotel": "arBellevuehotel",
//   "Offsite": "offsite",
//   "HappyApp Wallet": "happyappWallet",
//   "HyperMart": "hyperMart",
//   "Lee Plaza": "leePlaza",
//   "Uymatiao Shipping": "uymatiaoShipping",
//   "All Easy": "allEasy",
//   "AR Act": "arAct",
//   "Share Treat": "shareTreat",
//   "Total Non-Cash": "total_noncash",
//   "Total Payments": "total_payments",
//   "Bulk Wholesale": "bulkWholesale",
//   "Others Specify": "othersSpecify",
//   "Catering Manual": "cateringManual",
//   "Offsite Selling": "offsiteSelling",
//   "Reseller Manual": "resellerManual",
//   "Snackshop Manual": "snackshopManual",
//   "Delivery Fee Manual": "deliveryfeeManual",
//   "Cart Sales": "cartSales",
//   "Consignment": "consignment",
//   "Total Special Sales": "totalSpecialSales",
//   "Overall Sales": "overall_sales",
//   "Transaction Value": "transaction_value",
//   "Senior Citizen Disc": "srCitizen",
//   "PWD Discount": "pwdDisc",
//   "Other Discount": "otherDisc",
//   "Transaction Count POS": "transactionCountPos",
//   "GC Originating Store": "gcOriginatingStore",
//   "GC Serial Number": "gcSerialNumber",
//   "Terminal ID": "terminalId",
//   "Voids": "voids",
// };
